import { IonModal, IonHeader, IonToolbar, IonTitle, IonContent, IonItem, IonLabel, IonIcon } from '@ionic/react';
import { checkmarkCircle, ellipseOutline, earth } from 'ionicons/icons';
import { Users } from 'lucide-react';
import { UseFormReturn } from 'react-hook-form';
import { PostFormValues } from '@/hooks/post/usePostForm';
import { useTranslation } from 'react-i18next';

type AudienceSelectorProps = {
  form: UseFormReturn<PostFormValues>;
  isOpen: boolean;
  onClose: () => void;
};

export function AudienceSelector({ form, isOpen, onClose }: AudienceSelectorProps) {
  const { t } = useTranslation('MGP');

  return (
    <IonModal
      isOpen={isOpen}
      onDidDismiss={onClose}
      initialBreakpoint={0.4}
      breakpoints={[0, 0.4]}
      backdropBreakpoint={0}
    >
      <IonHeader color='card'>
        <IonToolbar>
          <IonTitle>
            {t('audience')}
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div className="space-y-3">
          <IonItem
            onClick={() => {
              form.setValue('audience', 0);
              onClose();
            }}>
            <div slot="start" className="flex items-center justify-center size-10 rounded-md bg-blue-500">
              <IonIcon icon={earth} className="size-5 text-white" />
            </div>
            <IonLabel>{t('public')}</IonLabel>
            <IonIcon
              icon={form.getValues('audience') === 0 ? checkmarkCircle : ellipseOutline}
              className={`size-5 rounded-full flex` + (form.getValues('audience') === 0 ? ' text-green-500' : ' text-foreground')}
            />
          </IonItem>

          <IonItem
            onClick={() => {
              form.setValue('audience', 1);
              onClose();
            }}>
            <div slot="start" className="flex items-center justify-center size-10 rounded-md bg-green-500">
              <Users className="size-5 text-white" />
            </div>
            <IonLabel>{t('friends')}</IonLabel>
            <IonIcon
              icon={form.getValues('audience') === 1 ? checkmarkCircle : ellipseOutline}
              className={`size-5 rounded-full flex ` + (form.getValues('audience') === 1 ? ' text-primary' : ' text-foreground')}
            />
          </IonItem>
        </div>
      </IonContent>
    </IonModal>
  );
}
